import { useAIHubEnabled } from '@office-start/ai-hub-config-service';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { Page, withLazyErrorBoundary, } from '@office-start/office-home-app-shared';
import React, { lazy, useMemo } from 'react';
import { CreatePageV2 } from '../CreatePage/CreatePageV2';
import { CreatePageRefresh } from './CreatePageRefresh';
var CreateComponentLazyBoundary = withLazyErrorBoundary(lazy(function () {
    return import(
    /* webpackChunkName: "create-center" */ '@office-start/create-component');
}), 'CreateComponent');
export var CreatePage = function (entityId, subEntityId) {
    var CreateInternal = function () {
        return (React.createElement(Page, { name: "Create" },
            React.createElement(CreateComponentLazyBoundary, null)));
    };
    var CreateWrapper = function () {
        var isAIHubEnabled = useAIHubEnabled();
        var featureGates = useFeatureGates().data;
        var isCreateRefreshEnabled = useMemo(function () {
            var _a, _b;
            return (((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.createGates) === null || _b === void 0 ? void 0 : _b.createRefreshEnabled) || false);
        }, [featureGates]);
        return isAIHubEnabled ? (isCreateRefreshEnabled ? (React.createElement(CreatePageRefresh, null)) : (React.createElement(CreatePageV2, null))) : (React.createElement(CreateInternal, null));
    };
    return CreateWrapper;
};
//# sourceMappingURL=CreatePage.js.map